import { PageLayout, Content } from "aldoo-ra/Layouts"
import Footer from "../Footer"

export default function Site({ children }) {
  return (
    <PageLayout>
      <Content>{children}</Content>
      <Footer />
    </PageLayout>
  )
}
